import React, { FC, useState } from 'react'

export type Item = {
  name: string
}

export type Props = {
  label: string
  options: Item[]
  onRadioChange: (val: number) => void
}

export const Radio: FC<Props> = ({ options, label, onRadioChange }) => {
  const [active, setIsActive] = useState<number>(0)

  function changeRadio(e: number) {
    setIsActive(e)
    onRadioChange(e)
  }

  return (
    <div className="Visualizer-group">
      <label className="Visualizer-label">{label}</label>
      <div className="Visualizer-radioGroup">
        {options.length > 0 &&
          options.map((item, i) => (
            <div
              className={`Visualizer-radio ${active === i ? 'selected' : ''} `}
              key={i}
              onClick={() => changeRadio(i)}
            >
              {item.name}
            </div>
          ))}
      </div>
    </div>
  )
}
